import { Navigate } from "react-router-dom";
import { routes } from "src/constants/routes.module";
import { useAppSelector } from "src/redux/store";

type AuthRouteProps = {
  element: () => JSX.Element;
  path?: string;
  exact?: boolean;
  index?: boolean;
  isAuthRoute?: boolean;
};

const AuthRoute = ({
  element: Component,
  isAuthRoute = false,
  path = "/",
  exact = false,
  index = false,
  ...rest
}: AuthRouteProps) => {
  const user = useAppSelector((state) => state.root.user);

  return user.isLoggedIn ? (
    <Navigate to={routes.home.path} />
  ) : (
    <Component {...rest} />
  );
};

export default AuthRoute;
